import React, {useState} from "react";
import {Col, Collapse, Row} from "react-bootstrap";

/**
 * Painel colapsável equivalente ao <Collapse.Item> do element-react, montado sobre o
 * <Collapse> do react-bootstrap (API estável entre react-bootstrap 1.x e 2.x).
 */
function CollapsePanel({title, defaultOpen = false, children}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="collapse-panel" style={{width: '100%'}}>
      <div className="collapse-panel-header d-flex align-items-center justify-content-between clickable"
           style={{padding: '10px 0', borderBottom: '1px solid rgba(0,0,0,.125)'}}
           onClick={() => setOpen(o => !o)}>
        <div>{title}</div>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{fontSize: '12px', opacity: .6}}/>
      </div>
      <Collapse in={open}>
        <div>
          <div style={{padding: '10px 0'}}>{children}</div>
        </div>
      </Collapse>
    </div>
  );
}

function getDateBackgroundColor(data) {
  let nowDate = new Date().getTime();
  let deliveryDate = new Date(data.deliveryDate).getTime();
  let alertDate = new Date(data.alertDate).getTime();

  let className = ''//`${styles.actionCard} px-2 py-3 my-3 clickable`;
  if (data.done) {
    return `${className} action-success-color-background`;
  } else if (nowDate < alertDate) {
    return `${className} action-warning-color-background`;
  } else if (nowDate >= alertDate && nowDate < deliveryDate) {
    return `${className} action-attention-color-background`;
  } else if (nowDate >= deliveryDate) {
    return `${className} action-danger-color-background`;
  }
}

function getFormattedDate(date) {
  if (date === null || date === undefined) {
    return "Não possui";
  } else {
    let cdDate = new Date(date);
    return cdDate.toLocaleDateString("pt-BR");
  }
}

function getFormattedTime(date) {
  if (date !== null || date !== undefined) {
    let cdDate = new Date(date);
    let hour = cdDate.getHours();
    let minutes = cdDate.getMinutes();
    let seconds = cdDate.getSeconds() === 0 ? "00" : cdDate.getSeconds();
    return hour + ":" + minutes + ":" + seconds;
  }
}

function getTaskDone(tasks) {
  let tasksDoneCount = 0;
  for (let i = 0; i < tasks.length; i++) {
    if (tasks[i].done) {
      tasksDoneCount++;
    }
  }

  return tasksDoneCount;
}

function getCurrentTask(tasks) {
  let currentTaskIndex;

  tasks.sort((a, b) => {
    if (a.index > b.index) {
      return 1;
    }
    if (a.index < b.index) {
      return -1;
    }
    return 0;
  });

  for (let i = 0; i < tasks.length; i++) {
    if (!tasks[i].done) {
      currentTaskIndex = i;
      break;
    }
  }

  return currentTaskIndex === undefined
    ? ""
    : tasks[currentTaskIndex].taskType.name;
}

function RenderItem(descricao, valor, classe = '') {
  if (!Boolean(valor)) return null
  const style = {
    label: {
      margin: '5px',
      fontWeight: 'bold'
    }
  }
  return (
    <Col xs={12} md={3}>
      <label style={style.label} className={classe}>{descricao}:</label>
      <b>{valor}</b>
    </Col>
  );
}

function ActionCard({action, setShowModalInsertAction, title, index}) {

  return (
    <div
      style={{border: '1px solid #dfe6ec', borderRadius: 5, marginBottom: 20, padding: 10}}
      className={getDateBackgroundColor(action)}
      /*onClick={() => setShowModalInsertAction(true, action)}*/
    >
      <CollapsePanel
        defaultOpen={index === 'index-0'}
        title={
          // eslint-disable-next-line
          <a onClick={() => setShowModalInsertAction(true, action)}>
            <span>{title.length > 40 ? title.substring(0, 40) : title}</span>
          </a>
        }>
        <Row>
          {RenderItem(action.tasks.length > 0 ? "Solicitado por" : "Criado por", action.creator.name)}
          {RenderItem('Data/Hora de criação', getFormattedDate(action.createDate) + " - " + getFormattedTime(action.createDate))}
          {RenderItem('Agendado para', action?.responsibleUser?.name)}
          {RenderItem('Tarefa Atual', getCurrentTask(action.tasks) === "" ? null : getCurrentTask(action.tasks))}
          {RenderItem('Tarefas', action.tasks.length ? getTaskDone(action.tasks) + " / " + action.tasks.length : "N/A tarefas")}
          {RenderItem('Nível de acesso', action.privaty ? "Interno" : "Externo")}
          {RenderItem('Data de alerta', action.alertDate ? getFormattedDate(action.alertDate) : null, 'alert-color')}
          {/*{RenderItem('Documentos', action.documents.length)}*/}
          {RenderItem('Data de entrega', action.deliveryDate ? getFormattedDate(action.deliveryDate) : null, 'deadline-color')}
          <Col xs={12}>
            <div style={{border: '1px solid #dfe6ec', borderRadius: 5, margin: 5, padding: 5, color: '#48576a'}}>
              <CollapsePanel title="  Descrição">
                <span dangerouslySetInnerHTML={{__html: action.additionalInformation}}/>
              </CollapsePanel>
            </div>
          </Col>
        </Row>
      </CollapsePanel>
    </div>
  );
}

export default ActionCard;
